"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get makeEditorText () {
        return makeEditorText;
    },
    get makeEditorTextWithOptions () {
        return makeEditorTextWithOptions;
    },
    get makeTiptapEditorText () {
        return makeTiptapEditorText;
    }
});
const _draftDemoContent = require("./draftDemoContent");
const _helpers = require("../helpers");
function wrapInDraft(text) {
    // kinda pulled from behind
    return `{"blocks":[{"key":"973ih","text":"${text}","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}`;
}
function makeRawText(words, sentences = 1) {
    const wordCount = words || (0, _helpers.d20)() + 3;
    if (sentences > 1) {
        return Array.from(new Array(sentences), ()=>(0, _helpers.sentence)({
                words: wordCount
            }));
    }
    return [
        (0, _helpers.sentence)({
            words: wordCount
        })
    ];
}
function getMarkup({ demo, legacy, rawText, excerpt = '' } = {}) {
    if (demo && !legacy) {
        return JSON.stringify(_draftDemoContent.demoContent);
    }
    if (legacy) {
        return [
            excerpt === null || excerpt === void 0 ? void 0 : excerpt.trim(),
            ...rawText
        ].filter((x)=>!!x).map((t)=>`<p>${t}</p>`).join('');
    }
    return wrapInDraft(excerpt.trim() + rawText.join(' '));
}
function makeEditorText(legacy, demo = false) {
    return makeEditorTextWithOptions({
        legacy,
        demo
    });
}
function makeTiptapEditorText(paragraphs) {
    return {
        excerpt: paragraphs.join(' ').slice(0, 100),
        html: {
            type: 'tiptap',
            markup: JSON.stringify({
                version: '1',
                document: {
                    type: 'doc',
                    content: paragraphs.map((paragraph)=>({
                            type: 'paragraph',
                            attrs: {
                                indentType: null,
                                indentation: null,
                                textAlign: 'left'
                            },
                            content: [
                                {
                                    type: 'text',
                                    text: paragraph
                                }
                            ]
                        }))
                },
                features: []
            }),
            features: JSON.stringify([
                {
                    type: 'TIPTAP_FEATURE',
                    data: {
                        tiptap: true,
                        version: 1
                    }
                },
                {
                    type: 'WORD_COUNT_FEATURE',
                    data: {
                        words: 5,
                        chars: 22
                    }
                },
                {
                    type: 'MEDIA_COUNT_FEATURE',
                    data: {
                        emoji: 0,
                        emotes: 0,
                        images: 0,
                        mentions: 0,
                        video: 0,
                        galleries: 0
                    }
                },
                {
                    type: 'IS_EMPTY_FEATURE',
                    data: {
                        isEmpty: false
                    }
                }
            ])
        }
    };
}
function makeEditorTextWithOptions({ legacy, demo, words, sentences, excerpt } = {}) {
    const rawText = makeRawText(words, sentences);
    return {
        excerpt: (excerpt === null || excerpt === void 0 ? void 0 : excerpt.trim()) || rawText.slice(0, 100).join(' '),
        html: {
            type: legacy ? 'writer' : 'draft',
            markup: getMarkup({
                demo,
                legacy,
                rawText,
                excerpt
            }),
            features: ''
        }
    };
}
